import { ComponentStyleConfig } from "@chakra-ui/react";
import Checkbox from "./checkbox";

const Radio: ComponentStyleConfig = { baseStyle: Checkbox.baseStyle };

export default Radio;
